import { memoize } from "lodash";
import { nameToApiIdentifier } from "../../ApiIdentified";
import { assert } from "../../utils";
import type { ShopifyApiVersion } from "./ShopifyApiVersion";
import { INTERNAL_SHOPIFY_API_VERSION } from "./ShopifyApiVersion";
import { ShopifyModelMetadata, shopifyModelSpecForVersion } from "./ShopifyModelMetadata";

export const maybeGetShopifyModelApiIdentifierByModelKey = memoize(
  (modelKey: string, apiVersion?: ShopifyApiVersion) => {
    const spec = shopifyModelSpecForVersion(modelKey, apiVersion ?? INTERNAL_SHOPIFY_API_VERSION);
    if (spec) {
      return nameToApiIdentifier(spec.name);
    }
  },
  (modelKey, apiVersion) => `${modelKey}--${apiVersion}`
);

export const getShopifyModelApiIdentifierByModelKey = (modelKey: string, apiVersion?: ShopifyApiVersion) => {
  return assert(
    maybeGetShopifyModelApiIdentifierByModelKey(modelKey, apiVersion),
    `Could not get the Shopify model API identifier for model key "${modelKey}"`
  );
};

export const maybeGetShopifyModelKeyByDefaultApiIdentifier = memoize(
  (defaultApiIdentifier: string, apiVersion?: ShopifyApiVersion) => {
    const modelKey = Object.keys(ShopifyModelMetadata).find((modelKey) => {
      const spec = shopifyModelSpecForVersion(modelKey, apiVersion ?? INTERNAL_SHOPIFY_API_VERSION);
      if (spec) {
        return nameToApiIdentifier(spec.name) === defaultApiIdentifier;
      }
    });

    return modelKey;
  },
  (modelKey, apiVersion) => `${modelKey}--${apiVersion}`
);

export const getShopifyModelKeyByDefaultApiIdentifier = (defaultApiIdentifier: string, apiVersion?: ShopifyApiVersion) => {
  return assert(
    maybeGetShopifyModelKeyByDefaultApiIdentifier(defaultApiIdentifier, apiVersion),
    `Could not get the Shopify model key for API identifier "${defaultApiIdentifier}"`
  );
};
